module.exports = __webpack_public_path__ + "a7f6fcb28ed96049e61f7acebe8f263f.png";